import * as FeelingFactorsConstants from '../constants';
import {filter} from 'underscore';

const initialState = {
  collection: [],
  isFetching: false,
  sorting: {
    sort: 'asc',
    order: 'created_at',
    query: ''
  },
  pagination: {
    total: 0,
    perPage: 10,
    totalPages: 0,
    page: 0
  }
};

export function feelingFactors(state = initialState, action) {
  switch (action.type) {
    case FeelingFactorsConstants.FEELING_FACTORS_FETCH_STARTED:
      return Object.assign({}, state, {isFetching: true});
    case FeelingFactorsConstants.FEELING_FACTORS_FETCH_COMPLETED:
      return Object.assign({}, state, {
        collection: action.feelingFactors,
        pagination: action.pagination,
        sorting: action.sorting,
        isFetching: false
      });
    case FeelingFactorsConstants.FEELING_FACTOR_DELETE_COMPLETED: {
      const newFeelingFactors = filter(state.collection, (feelingFactor) => feelingFactor.id !== action.feelingFactor.id);

      return Object.assign({}, state, {collection: newFeelingFactors});
    }
    default:
      return state;
  }
}
